import React, { useContext, useEffect, useState } from "react";
// import "./Edit_User_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import { Update, findOne } from "../../../utils/apis/matka/store/store";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";

function Edit(props) {
  const { UnauthorizedLogOut } = useContext(Context);
  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const result = await Update(id, data);
      const response = result.data;

      if (HTTPS.ALREADY_REPORTED.code !== response?.code) {
        await setShowModal({
          code: response.code,
          message: response.data,
        });
        setTimeout(() => {
          setShowModal(0);
          props.onHide();
        }, 1000);
      } else {
        setError("name", {
          message: response?.errors?.name?.msg,
        });
      }
    } catch (error) {
      setError("name", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);
      console.error(error.message);
    }
  };

  const GetEditData = async () => {
    if (!id) return;

    try {
      const response = await findOne(id);

      reset({
        name: response.data.data.name,
        chart_link: response.data.data.chart_link,
        status: response.data.data.status,
      });
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    GetEditData();
  }, [id]);

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal_Heading modalHeading={"Edit Country"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-md-12 mt-3">
                      <Form.Group className="form-field">
                        <Form.Label>Store Name*</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Store Name"
                          className={classNames({
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "Store name is required",
                            maxLength: {
                              value: 100,
                              message: "Store name cannot exceed 100 characters",
                            },
                          })}
                        />
                        {errors.name && (
                          <span className="text-danger">{errors.name.message}</span>
                        )}
                      </Form.Group>
                    </div>


                    <div className="col-md-12 mt-3">
                      <Form.Group className="form-field">
                        <Form.Label>Chart Link</Form.Label>
                        <Form.Control
                          type="url"
                          placeholder="https://example.com/chart"
                          className={classNames({
                            "is-invalid": errors?.chart_link,
                          })}
                          {...register("chart_link", {
                            pattern: {
                              value: /^https?:\/\/.+$/i,
                              message: "Please enter a valid URL",
                            },
                          })}
                        />
                        {errors.chart_link && (
                          <span className="text-danger">
                            {errors.chart_link.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <Form.Group className="mt-3">
                    <Form.Check
                      type="switch"
                      label="Active"
                      {...register("status")}
                    />
                  </Form.Group>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
